/**
 * System checkTools Store
 *
 * @since 2018-03-12
 * @author devp010
 */

export const state = () => ({
  basicOptions: {},
  basicInits: {},
  txtBoxes: {}
})

export const mutations = {
}

export const actions = {
  // clear 버튼 클릭
  async onProcessClick () {}
}

export const getters = {
}

export const strict = false
